<rask-fieldset-toggle
    label="Destinerad"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Destinerad"
        [formControlName]="name"
        [items]="options"
        [selected]="control.value">
    </rask-checkbox-list>
</rask-fieldset-toggle>